import React from 'react';
import { connect } from 'react-redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Mixpanel } from '../../redux/Mixpanel';
import {
    Row,
    Button,
    Form,
    FormGroup,
    Col,
    Container,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import CustomInput from '../../components/CustomInput';
import CustomLabel from '../../components/CustomLabel';
import { IonButton } from '@ionic/react';

import {
    showLoading,
    fetchPropertyTenants,
    reallocatePayment,
    fetchCurrency,
    fetchOptions
} from '../../redux/actions';
import { check_empty_field } from './validationChecks';
import _ from 'lodash';
import { renderTenantSearchMenu } from '../../utils';

const mapDispatchToProps = {
    showLoading,
    fetchPropertyTenants,
    reallocatePayment,
    fetchCurrency,
    fetchOptions
};

const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        payments: state.payments,
        currency: state.currency,
        options: state.options
    };
}


class ReallocatePaymentForm extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            tenantOptions: [],
            tenant: [],
            propertyId: "",
            errors: {
                tenant: "",
            },
        }
        this.setFieldValues = this.setFieldValues.bind(this);
    }

    async componentDidMount() {
        if(_.isEmpty(this.props.currency)){
            this.props.showLoading(true);
            await this.props.fetchCurrency();
        }
        if(_.isEmpty(this.props.options)){
            this.props.showLoading(true);
            await this.props.fetchOptions();
        }

        this.setState({
            propertyId: Object.values(this.props.properties).length === 1 ? Object.values(this.props.properties)[0].propertyId : ""
        })
        // Mixpanel.track("Reallocate payment to another tenant modal: mounted");
    }

    async validateInput(name, value){
        let val = String(value);
        let isValid = true;
        let checks = [];

        switch(name){
            case "tenant":
                checks = [check_empty_field];
                break;
            default:
                break;
        }

        await this.setState((prevState) => {
            let errors = {...prevState.errors};
            let numErrors = prevState.numErrors;
            for (let index in checks){
                let previousError = prevState.errors[name];
                errors[name] = checks[index](val);

                if (errors[name].length > 0){
                    if (previousError.length == 0){
                        numErrors += 1
                    }
                    isValid = false;
                    break;
                }else if(previousError.length > 0){
                    numErrors -= 1
                }
            }
            return {
               errors,
               numErrors
            };
        });
        return isValid;
    }


    async setTenantOptions(propertyId=""){
        let tenantOptions = [];

        if(propertyId){
            this.props.showLoading(true)
            const action = await this.props.fetchPropertyTenants({propertyIds:[propertyId]});
            for(let tenant of Object.values(action.payload.tenants)){
                if(!tenant.archived){
                    tenantOptions.push(this.getTenantOption(tenant));
                }
            }
        }
        let selectedTenant = this.getTenantOption(this.state.tenantDetails);

        this.setState({
            tenantOptions,
            tenant: selectedTenant? [selectedTenant] : []
        });

    }

    async onSubmit(event){
        event.preventDefault();
        let fields = ["tenant"];
        let invalid_fields = fields.filter((field)=> !(this.validateInput(field, this.state[field])));
        if (invalid_fields.length == 0) {
            this.props.showLoading(true);
            const action = await this.props.reallocatePayment(this.state.tenant[0].tenantDetails.tenantId, this.props.paymentId);
            if(!action.errors){
                this.setFieldValues();
                if(this.props.onSuccessCallBack){
                    this.props.onSuccessCallBack();
                }
            }
        }
        Mixpanel.track("Reallocate payment to tenant form: Reallocate tenant btn");
    }

    setFieldValues(propertyId="", tenant=[]){
        this.setState({
            propertyId, tenant
        })
    }

    getTenantOption(tenant){
        let accountId = "";
        if (tenant){
            accountId = tenant.accountId? tenant.accountId + "-" : "";
            let label = "";
            if(tenant?.archived){
                label += "[Archived] - "
            }
            label += accountId + tenant.firstName + " " + tenant.lastName;
            if(tenant.propertyId in this.props.properties){
                label += " (" + this.props.properties[tenant.propertyId].propertyName

                if(tenant.unitId in this.props.units){
                    label += " : " + this.props.units[tenant.unitId].unitName
                }

                label += ")"
            }

            return {
                id: tenant.tenantId,
                tenantDetails: tenant,
                label
            };
        }{
            return null;
        }
    }

    async handleSelectProperty(event){
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { propertyId } = prevState;
            if (propertyId != value){
                this.setTenantOptions(value);
                propertyId = value;
            }
            return {
                propertyId
            };
        });
    }

    async handleChangedOptions(name, selected){
        this.setState({[name]: selected});
        this.validateInput(name, selected);
    }

    render(){
        let tenantName;
        let unitName;
        if (this.props.payments[this.props.paymentId] && this.props.payments[this.props.paymentId]?.tenant){
            tenantName = this.props.payments[this.props.paymentId]?.tenant?.firstName + " " + this.props.payments[this.props.paymentId]?.tenant?.lastName
            unitName = this.props.units[this.props.payments[this.props.paymentId]?.tenant?.unitId]?.unitName
        }

        return (
        <Container>
            <Row>
                <Row className="">
                    <Col lg={12}>
                        <h5>Re-allocate Payment to another {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}</h5>
                        <br />
                        {this.props.paymentId && this.props.payments[this.props.paymentId] && (
                        <div className="mb-3">
                            <h6>
                                {`Amount ${this.props.currency.customerCurrency} ${this.props.amount || this.props.payments[this.props.paymentId]?.amount}`}
                            </h6>
                            <h6>
                                {`Paid by ${tenantName} (${unitName})`}
                            </h6>
                        </div>
                        )}

                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <FormGroup row>
                            <CustomLabel sm={3} md={3} for="propertyId">
                                Select {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                            </CustomLabel>
                            <Col sm={8} md={9} className="">
                                <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                                    <CustomInput
                                        type="select"
                                        id="propertyId"
                                        name="propertyId"
                                        className="mr-2"
                                        onChange={this.handleSelectProperty.bind(this)}
                                        value={this.state.propertyId}
                                    >
                                        <option key={""} value={""}>Select {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} Property</option>
                                        {_.map(this.props.properties, (property, index) => (
                                            <option key={property.propertyId} value={property.propertyId}>
                                                {property.propertyName}
                                            </option>
                                        ))}
                                    </CustomInput>
                                </Col>

                                <Col className="mt-2" style={{maxWidth: '450px'}} xs={12} sm={12}>
                                    <Typeahead
                                        emptyLabel={this.state.propertyId==="" ? `Please first select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} property.` : `Choose ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}. No matches found.`}
                                        placeholder={`Select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant(s)" : "member(s)"} ...`}
                                        clearButton
                                        id='tenant'
                                        options={this.state.tenantOptions}
                                        name="tenant"
                                        selected={this.state.tenant}
                                        paginate={false}
                                        maxResults={10000000}  // chose a high number because we don't want to handle pagination. Just show all results.
                                        onChange={this.handleChangedOptions.bind(this, "tenant")}
                                        renderMenu={renderTenantSearchMenu}
                                        >
                                        </Typeahead>
                                        {this.state.errors.tenant.length > 0 && <p className="text-danger">{this.state.errors.tenant}</p>}
                                </Col>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>
            </Row>

            <Row>
                <Col sm={12}>
                    <Form onSubmit={this.onSubmit.bind(this)}>
                    <IonButton
                        style={{
                            backgroundColor: colorTheme["primary"]["700"],
                            color: 'white' }}
                        size='md'
                        id="reallocatePaymentFormBtn"
                        type="submit"
                        disabled={this.state.tenant.length==0}
                        // onClick={}
                        >
                        Re-allocate Payment
                    </IonButton>
                    </Form>
                </Col>
            </Row>
        </Container>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReallocatePaymentForm);